import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "4 4 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.75781 16.2427L16.2431 7.75739",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.2431 16.2426L7.75781 7.75732",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgX;
